import { ELingua } from "../services/backend/naar-api-client";

export type LangCode = 'it' | 'en' | 'fr' | 'de' | 'nl' | 'zu';
export const AvailableLangCodes: LangCode[] = ['it', 'en', 'fr', 'de', 'nl', 'zu'];

export function LangCodeToELingua(langCode: LangCode | string): ELingua {
	switch (langCode) {
		case 'it':
			return ELingua.Italiano;
		case 'en':
			return ELingua.English;
		case 'fr':
			return ELingua.Francais;
		case 'de':
			return ELingua.Deutsch;
		case 'nl':
			return ELingua.Dutch;
		case 'zu':
			return ELingua.Debug;
		default:
			throw new Error(`Unsupported language code: ${langCode}`);
	}
}

export function ELinguaToLangCode(elingua: ELingua): LangCode {
	switch (elingua) {
		case ELingua.Italiano:
			return 'it';
		case ELingua.English:
			return 'en';
		case ELingua.Francais:
			return 'fr';
		case ELingua.Deutsch:
			return 'de';
		case ELingua.Dutch:
			return 'nl';
		case ELingua.Debug:
			return 'zu';
		default:
			throw new Error(`Unsupported ELingua value: ${elingua}`);
	}
}